<!-- <div class="order-reports-container col-md-12 no-padding">
    <div id="ordersreport">
        <div class="row no-margin">
            <div class="col-md-12 no-padding">
                <div id="icons-container" class="row float-right paddingtop-10">
                    <div class="col-md-12 no-padding">
                        <div class="col-md-3 right-padding-0">
                            <span (click)="addToFavorite()">
                                <i class="fa-heart-o fa pointer icon-heart"
                                    title="{{'reports.Add to Favorite' |translate |translateKey }}"></i>
                            </span>
                        </div>
                        <div class="col-md-3 right-padding-0">
                            <button type="button" tabindex="0" (keyup.enter)="exportFile('print')" (click)="exportFile('print')"
                                class="iconButtons no-margin" [disabled]="isAllOrdersReportLoading || isLoading">
                                <span class="btn-label">
                                    <img class="excel-image" [src]="printIconUrl" alt="{{'customer-service.Print' |translate |translateKey }}"
                                        title="{{'customer-service.Print' |translate |translateKey }}" />
                                </span>
                            </button>
                        </div>        
                        <div class="col-md-3 right-padding-0">
                            <button type="button" tabindex="0" (keyup.enter)="exportFile('csv')" (click)="exportFile('csv')"
                                class="iconButtons no-margin" [disabled]="isAllOrdersReportLoading || isLoading">
                                <span class="btn-label">
                                    <img class="excel-image" [src]="excelIconUrl"
                                        alt="{{'reports.Export CSV' |translate |translateKey}}"
                                        title="{{'reports.Export CSV' |translate |translateKey}}"/>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 no-padding mt-10 mb-10">
            <div class="table-responsive">
                <table class="table-sm table-hover table-bordered" width="100%">
                    <thead>
                        <tr>
                            <th class="cursor-pointer">{{'bsn-reports.Country/Store' |translate |translateKey}}&nbsp;</th>
                            <th class="cursor-pointer">{{'bsn-reports.BSN Added Date' |translate |translateKey}}&nbsp;</th>
                            <th class="cursor-pointer">{{'bsn-reports.FBO ID' |translate |translateKey}}&nbsp;</th>
                            <th class="cursor-pointer">{{'bsn-reports.BSN' |translate |translateKey}}&nbsp;</th>
                            <th class="cursor-pointer">{{'bsn-reports.Date Of Birth' |translate |translateKey}}&nbsp;</th>
                        </tr>
                    </thead>
                    | paginate: {  id: 'order-reports-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount}
                    <tbody
                        *ngIf="!isLoading && bsnReports && bsnReports.length > 0">
                        <tr
                            *ngFor="let bsnReport of bsnReports | paginate: {  id: 'order-reports-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount}">
                            <td>{{countryName}}</td>
                            <td>{{bsnReport.createdDate ? (bsnReport.createdDate) : ''}}</td>
                            <td>{{bsnReport.distributorId ? (bsnReport.distributorId): ''}}</td>
                            <td>{{bsnReport.bsn ? (bsnReport.bsn) : ''}}</td>
                            <td>{{bsnReport.dob ? (bsnReport.dob) :''}}</td>                       
                        </tr>
                    </tbody>
                    <tbody
                        *ngIf="(!isLoading && (bsnReports && bsnReports.length === 0)) || (isResponseError && !isLoading)">
                        <tr>
                            <td colspan="29"  class="text-center ">{{'customer-service.No record(s) found' |translate | translateKey}}.</td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="isLoading">
                        <tr>
                            <td colspan="29" class="text-center">{{'customer-service.Loading Results, Please wait.'|translate | translateKey}}.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="mt-5 paddingbot-20"
                *ngIf="bsnReports && bsnReports.length > 0">
                <span>{{pageCount}} {{'customer-service.record(s) found' |translate |translateKey}}</span>
                <pagination-controls id="order-reports-pagination" (pageChange)="pageChange($event)" class="pull-right">
                </pagination-controls>
            </div>
        </div>
        <div class="col-md-12 padding-lr-0 paddingbot-20">
            <div class="col-md-4 padding-lr-0">
                <select class="form-control per-page-width" id="currentPageSize" [(ngModel)]="pageSize"
                    [disabled]="!(bsnReports && bsnReports.length > 0)"
                    (change)="pageSizeChange($event.target.value)" name="currentPageSize" #currentPageSize="ngModel">
                    <option *ngFor="let pageSize of pageSizes" [value]="pageSize">{{pageSize}}</option>
                </select>
            </div>
        </div>
    </div>
</div> -->

<div class="row w-100 no-margin message paddingtop-20"
    *ngIf="(!isLoading && (bsnReports && bsnReports.length === 0)) || (isResponseError && !isLoading)">
    <div class="w-100 messageContent text-center">
        <strong class="">{{'customer-service.No record(s) found' |translate | translateKey}}.</strong>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/reports/bsn-reports.component.html